import { createFileRoute, redirect } from "@tanstack/react-router"

import { generateMetaTags } from "@repo/seo/generate-meta-tags"
import { sharedConfig } from "~/lib/config/shared"
import { AuthLayout } from "~/modules/auth/components/auth-layout"
import { SignUpForm } from "./sign-up-form"

export const Route = createFileRoute("/_auth-layout/auth/sign-up")({
  component: SignUpScreen,
  beforeLoad: ({ context }) => {
    if (!sharedConfig.flags.signUpsEnabled) {
      throw redirect({
        to: "/auth/sign-in",
      })
    }

    if (context.user) {
      throw redirect({
        to: "/",
      })
    }
    return {
      pageTitle: "Sign Up",
    }
  },
  head: ({ match }) => ({
    meta: generateMetaTags({
      robots: ["noindex", "nofollow", "noarchive"],
      base: {
        title: `${match.context.pageTitle} | ${sharedConfig.appName}`,
        description: `Create an account with ${sharedConfig.appName}`,
        url: new URL(match.fullPath, sharedConfig.baseUrl).toString(),
      },
    }),
  }),
})

function SignUpScreen() {
  return (
    <AuthLayout title="Sign Up">
      <SignUpForm />
    </AuthLayout>
  )
}
